import React from 'react';
import styles from './InventoryDiscrepanciesBack.module.scss';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../Manage/FilterInTable';

const data = [
    {
        id: 1,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 2,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 3,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 4,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 5,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
];

const columns = [
    {
        name: 'Discrepancy ID',
        selector: (row) => row.discId,
        sortable: true,
    },
    {
        name: 'Shipment ID',
        selector: (row) => row.shipmentId,
        sortable: true,
    },
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        width: '250px',
    },
    {
        name: 'SKU ID',
        selector: (row) => row.skuId,
        sortable: true,
    },
    {
        name: 'Quantity Expected',
        selector: (row) => row.quantityExpected,
        sortable: true,
    },
    {
        name: 'Quantity Received',
        selector: (row) => row.quantityReceived,
        sortable: true,
    },
    {
        name: 'Discrepancy Notes',
        selector: (row) => row.discNotes,
        sortable: true,
    },
];

const customStyles = {
    table: {
        style: {
            borderLeft: '1px solid #D9D9D9',
            borderTop: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            borderRight: '1px solid #D9D9D9',

            div: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
            }
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            borderRight: '1px solid #D9D9D9',

            div: {
                whiteSpace: 'normal !important',
                wordWrap: 'break-word',
            }
        },
    },
};

const InventoryDiscrepanciesBack = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Inventory Discrepancies</h4>

            <div className={styles.inventoryDiscrepanciesContainer}>

                <FilterInTable componentName={"Inventory Discrepancies"} />

                <div className={styles.inventoryTable}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </div>
    )
}

export default InventoryDiscrepanciesBack;